import React from 'react';
import { AttachmentsColumnsProps } from '../../../../../../core/types/coreTypes';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import { useAppSelector } from '../../../../../../store/hooks';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import { pricelistAttachmentsFiltersSelector } from '../../../../../../store/selectors/pricelistSelectors';
import { setPricelistAttachmentsFilters } from '../../../../../../store/slices/pricelistSlice';
import AttachmentColumns from '../../../../../../common/components/attachments-table/AttachmentColumns';
import { useCoreAttachmentsColumns } from '../../../../../../core/hooks/useCoreAttachmentsColumns';

const PricelistAttachmentColumns:React.FC<AttachmentsColumnsProps> = ({
  isAll, checkAll, totalElements, indeterminate,
}) => {
  const allowedManage = usePermission(PermissionEnum.PricelistEditFields);
  const attachmentsFilters = useAppSelector(pricelistAttachmentsFiltersSelector);

  const {
    searchVl,
    pickerValue,
    setPickerValue,
    sortHandle,
    onChangeSearchHandle,
    searchPressHandle,
    pickerHandle,
  } = useCoreAttachmentsColumns(attachmentsFilters, setPricelistAttachmentsFilters);

  return (
    <AttachmentColumns
      allowedManage={!!allowedManage}
      isAll={isAll}
      indeterminate={indeterminate}
      checkAll={checkAll}
      sortHandle={sortHandle}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      totalElements={totalElements}
      searchVl={searchVl}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
      tableFilters={attachmentsFilters}
    />
  );
};

export default PricelistAttachmentColumns;
